import { z } from 'zod';

export const projectCreationSchema = z.object({
    name: z
        .string("Inserisci il nome del progetto")
        .min(1, 'Il nome del progetto è obbligatorio')
        .min(3, 'Il nome deve essere di almeno 3 caratteri')
        .max(100, 'Il nome non può superare i 100 caratteri'),

    customerId: z
        .string("Seleziona il cliente")
        .min(1, 'Il cliente è obbligatorio')
        .regex(/^[0-9a-fA-F]{24}$/, 'ID cliente non valido'),

    description: z
        .string()
        .max(1000, 'La descrizione non può superare i 1000 caratteri')
        .nullable()
        .optional(),

    teamLeaderId: z
        .string()
        .min(1, 'Il team leader è obbligatorio')
        .regex(/^[0-9a-fA-F]{24}$/, 'ID team leader non valido'),

    commercialIds: z
        .array(z.string().regex(/^[0-9a-fA-F]{24}$/, 'ID commerciale non valido'))
        .min(1, 'Almeno un commerciale deve essere assegnato')
        .max(10, 'Non è possibile assegnare più di 10 commerciali'),

    emailFrom: z
        .email('Formato email non valido')
        .optional()
        .nullable(),

    nameFrom: z
        .string()
        .optional()
        .nullable(),
});

export type ProjectCreationFormData = z.infer<typeof projectCreationSchema>;
